import { gqlPromise, type DefaultContext } from '@egw/clients'
import { type InvestmentInstrument } from '../../../models'

/**
 * Get Investment Account Detail
 * @param symbol - string
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<InvestmentAccountDetail>
 * @example const investmentAccountDetail = await getInvestmentAccountDetail();
 */
export const getInvestmentInstrument = async (
  symbol: string,
  context?: DefaultContext,
): Promise<InvestmentInstrument> => {
  const response = (await gqlPromise(
    {
      name: 'instrument',
      query: `
        query instrument($symbol: String!) {
            instrument(symbol: $symbol) {
                name
                description
                symbol
                priorClosePrice {
                    amount
                    currencyCode
                }
                image
            }
        }`,
    },
    { symbol },
    context,
  )) as { instrument: InvestmentInstrument }
  return response.instrument
}
